import React, { useState } from 'react';
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api';
import { Property } from '@lib/state';
import { Typography } from '@material-ui/core';
import { AddressDisplay } from '@lib/common';

interface PropertyMarker {
  id: string;
  property: Property;
  location: google.maps.LatLngLiteral;
}
interface Props {
  height: number;
  properties: Property[];
}

const apiKey = process.env.REACT_APP_API_GOOGLE_MAPS_API_KEY ?? '';
const mapId = process.env.REACT_APP_API_GOOGLE_MAPS_MAP_ID ?? '';

export const ContactMap: React.FC<Props> = ({ height, properties }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
    mapIds: [mapId],
  });

  const [selected, setSelected] = useState('');

  const locations: PropertyMarker[] = properties
    .filter(p => p.coordinates?.latitude && p.coordinates?.longitude)
    .map(p => ({
      id: p.id,
      property: p,
      location: { lat: p.coordinates!.latitude!, lng: p.coordinates!.longitude! },
    }));

  if (!locations.length) return null;

  const renderMap = () => {
    const bounds = new google.maps.LatLngBounds();
    locations.forEach(({ location }) => bounds.extend(location));

    return (
      <GoogleMap
        mapContainerStyle={{ height, maxHeight: '50vh' }}
        options={{ mapId } as google.maps.MapOptions}
        zoom={9}
        center={bounds.getCenter()}
        onLoad={map => {
          if (locations.length > 1) {
            map.fitBounds(bounds);
          }
        }}
      >
        {locations.map(({ id, location, property }) => (
          <Marker
            key={id}
            position={location}
            title={property.name}
            onClick={() => setSelected(id)}
          >
            {selected === id && (
              <InfoWindow onCloseClick={() => setSelected('')}>
                <>
                  <Typography variant="overline">{property.name}</Typography>
                  <AddressDisplay variant="body2" {...property.location} />
                </>
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    );
  };

  return isLoaded ? renderMap() : null;
};
